import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const PasswordWUT = props => {
  const {
    t
  } = useTranslation();
  const fieldType = FIELD_TYPES.PASSWORD;
  const {
    label
  } = props;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    type: "password",
    fieldType: fieldType,
    label: label,
    showPasswordTooltipText: t('forms.widget.modals.show-password-tooltip'),
    hidePasswordTooltipText: t('forms.widget.modals.hide-password-tooltip')
  }));
};
//# sourceMappingURL=password-wut.js.map